import debounce from '../../common/debounce.js'

export function getType(target) {
    const types = {
        'string': String,
        'number': Number,
        'object': Object,
        'function': Function,
    }

    if (typeof target === 'undefined') {
        return undefined;
    }

    if (target === null) {
        return null;
    }

    if (Array.isArray(target)) {
        return Array;
    }

    return types[typeof target];
}

export function isMoment(anyObj) {
    if (typeof window.moment === 'undefined') {
        return false;
    }

    return window.moment.isMoment(anyObj);
}

export function toDate(anyObj, forceTime = '00:00:00') {
    if (isMoment(anyObj)) {
        return anyObj.toDate();
    }

    const date = new Date(anyObj);

    if (date.toString() === 'Invalid Date') {
        return null;
    }

    if (getType(forceTime) === String) {
        const [ hours, minutes, seconds ] = forceTime.split(':')

        date.setHours(hours)
        date.setMinutes(minutes)
        date.setSeconds(seconds)
        date.setMilliseconds(0)
    }

    return date;
}

const saveStorage = debounce((storage, key, value) => {
    try {
        storage[key] = JSON.stringify(value)
    } catch(e) {
        console.warn('TablePagesMixins.saveFilters', e)
    }
}, 400);

// storage defaults to localStorage (old behaviour); views that want "per tab, until closed" pass sessionStorage
export function saveFilters(name, filters, storage = localStorage) {
    const key = `VueDataTable.filters.${ name }`
    
    saveStorage(storage, key, filters)
}

export function saveSort(name, sort, storage = localStorage) {
    try {
        storage[`VueDataTable.sort.${ name }`] = JSON.stringify(sort)
    } catch(e) {
        console.warn('TablePagesMixins.saveSort', e)
    }
}

export function loadSort(name, storage = localStorage) {
    try {
        return JSON.parse(storage[`VueDataTable.sort.${ name }`]) || null
    } catch(e) {
        return null
    }
}

// returns the saved string (SimpleSearch), true when saved filters were applied, otherwise undefined/null
export function loadFilters(name, filters, storage = localStorage, skip = []) {
    const key = `VueDataTable.filters.${ name }`
    
    if (!storage[key]) return;

    try {
        const savedFilters = JSON.parse(storage[key])
        // SimpleSearch case, only single string
        if (typeof savedFilters === 'string') {
            return savedFilters
        }
        // Filters object is nullish or something for some reason, skip
        if (!filters) return null;

        for (let key of Object.keys(savedFilters)) {
            if (skip.includes(key)) continue;
            filters[key] = savedFilters[key]
        }

        return true
    } catch(e) {
        console.warn('TablePagesMixins.loadFilters', e)
    }
}